<template>
    <div class="page">
        <box>
            <el-form label-position="right" label-width="100px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="库位编号" class="EL-Form-Item">
                        <el-input v-model="ChangeRecordSearch.laCode" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input v-model="ChangeRecordSearch.matCode" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="订单编号" class="EL-Form-Item">
                        <el-input v-model="ChangeRecordSearch.orderCode" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <!-- <el-col :lg="5" :xl="5" v-if="ChangeRecordSearch.fcCode">
                    <el-form-item label="批次号" class="EL-Form-Item">
                        <el-input v-model="ChangeRecordSearch.batchNo" placeholder="请输入" @change="saveSearch()"></el-input>
                    </el-form-item>
                </el-col> -->
                
                <el-col :lg="5" :xl="5" v-if="!ChangeRecordSearch.fcCode">
                    <el-form-item label="批次号" class="EL-Form-Item">
                        <el-input v-model="ChangeRecordSearch.batchNo" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <!-- <el-col :lg="5" :xl="5">
                    <el-form-item label="物料当前状态" class="EL-Form-Item">
                        <el-select multiple collapse-tags v-model="sckStatusList" clearable="clearable">
                            <el-option key="1" value="NORMAL" label="正常"></el-option>
                            <el-option key="2" value="FREEZE" label="拣配中"></el-option>
                            <el-option key="3" value="OVERTIME" label="过期"></el-option>
                            <el-option key="4" value="DELETE" label="作废"></el-option>
                            <el-option key="5" value="AGFREEZE" label="人工冻结"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col> -->
                <el-col :lg="5" :xl="5">
                    <el-form-item label="箱号" class="EL-Form-Item">
                        <el-input v-model="ChangeRecordSearch.boxBarcode" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="clickSelectList()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="ChangeRecordReset()">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
                <!-- <el-col :lg="9" :xl="9">
                    <el-form-item label="日期范围" class="EL-Form-Item">
                        <el-date-picker style="width: 280px" v-model="ChangeRecordSearch.date" value-format="yyyy-MM-dd HH:mm" type="datetimerange" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                    </el-form-item>
                </el-col> -->
                <el-col :lg="5" :xl="5">
                    <el-form-item label="开始日期" class="EL-Form-Item">
                        <el-date-picker v-model="ChangeRecordSearch.date[0]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="pickerOptions0"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="结束日期" class="EL-Form-Item">
                        <el-date-picker v-model="ChangeRecordSearch.date[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-form>
            <el-divider></el-divider>
            <plabel text="物料状态转换记录">
                <el-button v-authority="'BACK_MENU3_M20_B1'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <h-table :headerCellStyle="ChangeRecordData.headerCellStyle" style="height: 77vh" @pageChange="getStatusTransitionRecordList" :data="ChangeRecordData.data" pagination :nowPage.sync="ChangeRecordData.pageNum" :pageSize.sync="ChangeRecordData.pageSize" :total.sync="ChangeRecordData.total" @selectionChange="selectAllChangeRecord">
                <el-table-column type="selection" align="center"> </el-table-column>
                <el-table-column label="物料编号" prop="matCode" align="center">
                </el-table-column>
                <el-table-column label="物料描述" prop="matName" align="center">
                </el-table-column>
                <el-table-column label="订单编号" prop="orderCode" align="center">
                </el-table-column>
                <el-table-column label="物料数量" prop="matQuan" align="center">
                </el-table-column>
                <el-table-column label="库位编号" prop="laCode" align="center">
                </el-table-column>
                <el-table-column label="箱号" prop="boxBarcode" align="center" width="150px">
                </el-table-column>
                <el-table-column label="物料原状态" prop="oldStatus" align="center" width="105px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.oldStatus == 'NORMAL'">正常</span>
                        <span v-if="scope.row.oldStatus == 'FREEZE'">拣配中</span>
                        <!-- <span v-if="scope.row.oldStatus == 'OVERTIME'">过期</span>
                        <span v-if="scope.row.oldStatus == 'DELETE'">作废</span> -->
                        <span v-if="scope.row.oldStatus == 'AGFREEZE'">冻结</span>
                    </template>
                </el-table-column>
                <el-table-column label="物料当前状态" prop="status" align="center" width="120px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 'NORMAL'">正常</span>
                        <span v-if="scope.row.status == 'FREEZE'">拣配中</span>
                        <!-- <span v-if="scope.row.status == 'OVERTIME'">过期</span>
                        <span v-if="scope.row.status == 'DELETE'">作废</span> -->
                        <span v-if="scope.row.status == 'AGFREEZE'">冻结</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="原批次" prop="batchNo" align="center">
                </el-table-column>
                <el-table-column label="当前批次" prop="batchNoNew" align="center">
                </el-table-column> -->
                <el-table-column label="创建时间" prop="createTime" align="center" width="180px">
                </el-table-column>
                <!-- <el-table-column label="操作人工号" prop="personNumber" align="center">
                </el-table-column> -->
                <el-table-column label="操作人" prop="person" align="center">
                </el-table-column>
            </h-table>
        </box>
    </div>
</template>

<script>
    export default {
        name: "StatusTransitionRecord",
        data() {
            return {
                ChangeRecordData: {
                    data: [],
                    pageNum: 1,
                    pageSize: 20,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                ChangeRecordSearch: {
                    person: localStorage.getItem("user"),
                    fcCode: localStorage.getItem("fcCode") || "",
                    matCode: "",
                    orderCode: "",
                    status: "",
                    batchNo: "",
                    laCode: "",
                    boxBarcode: "",
                    date: [],
                },

                downloadLoading: false, //下载中

                //多选状态数组
                sckStatusList: [],

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注
                // 输入框延时加载
                isSetTimeout: null,
            };
        },
        watch: {
            ChangeRecordSearch: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.clickSelectList(newVal);
                    }, 1000)
                },
                deep: true,
            },
            sckStatusList: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.clickSelectList(newVal);
                    }, 1000)
                },
                deep: true,
            },
        },
        computed: {
            pickerOptions() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.ChangeRecordSearch.date[0]) {
                            return time.getTime() < new Date(_this.ChangeRecordSearch.date[0]);
                        }
                    }
                }
            },
            pickerOptions0() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.ChangeRecordSearch.date[1]) {
                            return time.getTime() > new Date(_this.ChangeRecordSearch.date[1]);
                        }
                    }
                }
            },
        },
        methods: {
            // 节流搜索
            saveSearch() {
                if (window.lazy) window.clearTimeout(window.lazy)
                window.lazy = window.setTimeout(() => {
                    this.clickSelectList()
                }, 1000)
            },
            // 点击查询按钮 重置页号
            clickSelectList(newVal) {
                this.ChangeRecordData.pageNum = 1;
                this.getStatusTransitionRecordList(newVal);
            },
            /**
             * 物料状态转换记录
             */
            getStatusTransitionRecordList: function() {
                let status = "";
                this.sckStatusList.forEach((item) => {
                    status += item + ","
                })
                this.$http
                    .request({
                        url: "/api/SplitMergeMatChange/getMatChangeRecordData",
                        method: "GET",
                        params: {
                            boxBarcode: this.ChangeRecordSearch.boxBarcode || null,
                            // person: this.ChangeRecordSearch.person || null,
                            fcCode: this.ChangeRecordSearch.fcCode || null,
                            matCode: this.ChangeRecordSearch.matCode || null,
                            orderCode: this.ChangeRecordSearch.orderCode || null,
                            //status: this.ChangeRecordSearch.status || null,
                            status: status || null,
                            batchNo: this.ChangeRecordSearch.batchNo || null,
                            laCode: this.ChangeRecordSearch.laCode || null,
                            beginTime: this.ChangeRecordSearch.date ?
                                this.ChangeRecordSearch.date[0] : null,
                            endTime: this.ChangeRecordSearch.date ?
                                this.ChangeRecordSearch.date[1] : null,
                            pageNum: this.ChangeRecordData.pageNum,
                            pageSize: this.ChangeRecordData.pageSize,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.ChangeRecordData.data = resp.data.list || [];
                            this.ChangeRecordData.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            /**
             * 多选
             */
            selectAllChangeRecord(val) {
                // console.log("=============", val);
            },
            //清空
            ChangeRecordReset() {
                this.ChangeRecordSearch = {
                    person: localStorage.getItem("user"),
                    fcCode: localStorage.getItem("fcCode") || "",
                    matCode: "",
                    matName: "",
                    status: "",
                    batchNo: "",
                    laCode: "",
                    boxBarcode: "",
                    date: [],
                };
                this.getStatusTransitionRecordList();
            },

            //表格导出
            downLoadFile() {
                this.downloadLoading = true;
                let status = "";
                this.sckStatusList.forEach((item) => {
                    status += item + ","
                })
                var paramsObj = {
                    boxBarcode: this.ChangeRecordSearch.boxBarcode || null,
                    // person: this.ChangeRecordSearch.person || null,
                    fcCode: this.ChangeRecordSearch.fcCode || null,
                    matCode: this.ChangeRecordSearch.matCode || null,
                    matName: this.ChangeRecordSearch.matName || null,
                    //status: this.ChangeRecordSearch.status || null,
                    //status: status || null,
                    batchNo: this.ChangeRecordSearch.batchNo || null,
                    laCode: this.ChangeRecordSearch.laCode || null,
                    beginTime: this.ChangeRecordSearch.date ? this.ChangeRecordSearch.date[0] : null,
                    endTime: this.ChangeRecordSearch.date ? this.ChangeRecordSearch.date[1] : null,
                    pageNum: 1,
                    pageSize: 999999,
                }

                this.$http.request({
                    url: '/api/SplitMergeMatChange/getMatChangeRecordData',
                    method: 'GET',
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoad(list) {
                import('@/libs/Export2Excel').then(excel => {
                    list.forEach(function(c) {
                        if (c.status == 'NORMAL') {
                            c['status'] = '正常'
                        } else if (c.status == 'FREEZE') {
                            c['status'] = '拣配中'
                        // } else if (c.status == 'OVERTIME') {
                        //     c['status'] = '过期'
                        // } else if (c.status == 'DELETE') {
                        //     c['status'] = '作废'
                        } else if (c.status == 'AGFREEZE') {
                            c['status'] = '冻结'
                        }

                        if (c.oldStatus == 'NORMAL') {
                            c['oldStatus'] = '正常'
                        } else if (c.oldStatus == 'FREEZE') {
                            c['oldStatus'] = '拣配中'
                        // } else if (c.oldStatus == 'OVERTIME') {
                        //     c['oldStatus'] = '过期'
                        // } else if (c.oldStatus == 'DELETE') {
                        //     c['oldStatus'] = '作废'
                        } else if (c.oldStatus == 'AGFREEZE') {
                            c['oldStatus'] = '冻结'
                        }
                    })
                    const tHeader = [ '物料编号', '物料描述', '订单编号' , '物料数量', '库位编号', '箱号', '物料原状态', '物料当前状态',
                        '创建时间',  '操作人'
                    ]
                    const filterVal = [ 'matCode', 'matName', 'orderCode', 'matQuan', 'laCode', 'boxBarcode', 'oldStatus', 'status',
                        'createTime', 'person'
                    ]
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '物料状态转换记录单'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "wh_inventory：导出物料状态转换记录"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },

            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "物料状态转化记录",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        showLoading: true,
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
        },
        activated(){
            /* 获取首页的数据 */
            this.getStatusTransitionRecordList();
        },
    };
</script>

<style scoped>
</style>